import type { UserLocation } from '@/firebase/types';

/** Match tolerance when resolving a user location from URL coordinates (degrees). */
export const FAVORITES_MAP_COORD_URL_EPS = 1e-5;

/**
 * Canonical path for a user-location detail view on the map favorites route.
 * Two numeric segments after /maps/saved — list views use a single slug (e.g. /maps/saved/my-list).
 */
export function userLocationMapDetailPath(lat: number, lng: number): string {
  const la = Number(lat.toFixed(6));
  const ln = Number(lng.toFixed(6));
  return `/maps/saved/${la}/${ln}`;
}

const USER_LOCATION_MAP_PATH_RE = /^\/maps\/saved\/([^/]+)\/([^/]+)\/?$/;

export function parseUserLocationMapPath(pathname: string): { lat: number; lng: number } | null {
  const m = pathname.match(USER_LOCATION_MAP_PATH_RE);
  if (!m) return null;
  const lat = parseFloat(m[1]);
  const lng = parseFloat(m[2]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
}

export function isUserLocationMapDetailPath(pathname: string): boolean {
  return parseUserLocationMapPath(pathname) != null;
}

/** Favorites routes in the map shell: index, lists, or lat/lng detail. */
export function isFavoritesMapPath(pathname: string): boolean {
  return (
    pathname === '/maps/saved' ||
    pathname === '/maps/saved/' ||
    pathname.startsWith('/maps/saved/')
  );
}

export function findLocationByCoords(
  locations: UserLocation[],
  lat: number,
  lng: number,
  eps: number = FAVORITES_MAP_COORD_URL_EPS
): UserLocation | undefined {
  return locations.find(
    (loc) =>
      Math.abs(loc.latitude - lat) < eps && Math.abs(loc.longitude - lng) < eps
  );
}

